import React, { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ITabItem } from "./types";

interface Props {
  className?: string;
  isActive?: boolean;
  tab: ITabItem;
}

export const TabItem: FC<Props> = ({ className, isActive, tab }) => {
  const { t } = useTranslation();

  const Icon = tab?.icon;

  const title =
    typeof tab.title === "string"
      ? tab.title
      : t(tab.title.i18nKey, tab.title.i18nParams);

  const combinedClassNames = cn(
    "justify-center items-center w-full h-3.4 gap-2 px-3 py-2 font-medium",
    {
      "!text-black-base": !isActive,
    },
    className
  );

  return (
    <Button
      className={combinedClassNames}
      variant={isActive ? ButtonVariants.PRIMARY : ButtonVariants.SECONDARY}
    >
      {Icon && (
        <Icon
          className={cn({
            "fill-svg-white-base": isActive,
          })}
        />
      )}
      {title}
    </Button>
  );
};
